import { Alert } from 'antd';
import { ReactElement } from 'react';

const isDev = import.meta.env.VITE_NODE_ENV === 'development';

export const TestBar = (): ReactElement | null => {
  if (!isDev) {
    return null;
  }
  return (
    <Alert
      title="Środowisko testowe"
      type="warning"
      style={{ borderRadius: 0, textAlign: 'center' }}
    />
  );
};
